module.exports = __webpack_public_path__ + "img/gastro.3b0de451.svg";